import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useHistory } from '../hooks/useHistory'
import { undo, redo } from '../store/editor'
import { useAuthStore } from '../store/auth'

export default function StudioTopbar({
  sceneName,
  onExport,
  onSave,
  saveState = 'idle',
}: {
  sceneName?: string
  onExport?: () => void
  onSave?: () => void
  saveState?: 'idle' | 'saving' | 'saved'
}) {
  const { t } = useTranslation()
  const nav = useNavigate()
  const { canUndo, canRedo } = useHistory()
  const user = useAuthStore((s) => s.user)
  return (
    <div className="studio-topbar">
      <button className="btn btn-ghost btn-sm" onClick={() => nav('/')}>
        ← {t('common.back')}
      </button>
      <div className="studio-scene-name">{sceneName}</div>
      <div className="studio-actions">
        <button className="btn btn-outline btn-sm" disabled={!canUndo} onClick={() => undo()} title={t('common.undo')}>
          {t('common.undo')}
        </button>
        <button className="btn btn-outline btn-sm" disabled={!canRedo} onClick={() => redo()} title={t('common.redo')}>
          {t('common.redo')}
        </button>
        {user && onSave && (
          <button
            className="btn btn-outline btn-sm"
            onClick={onSave}
            disabled={saveState === 'saving'}
            title={t('studio.saveTitle')}
          >
            {saveState === 'saving' ? '◐ …' : saveState === 'saved' ? t('studio.saved') : `💾 ${t('common.save')}`}
          </button>
        )}
        <button className="btn btn-primary btn-sm" onClick={onExport} title={t('common.export')}>
          {t('common.export')}
        </button>
      </div>
    </div>
  )
}
